import { FunctionComponent, useEffect, useMemo, useState } from 'react'

import { Icons } from 'atoms'
import { Box, HStack, Pressable, Text } from 'native-base'
import { getUsersDisplayMap, UsersDisplayMap } from 'src/utils/usersDisplay'

import { FiltersRecord } from '../OrganizationScreen.types'

const opportunityTypeLabels: Record<string, string> = {
  '1': 'Oportunidades',
  '2': 'Base Ativa'
}

const getPriorityLabel = (raw: string) => `Prioridade ${raw}`

type ActiveFiltersBarProps = {
  filters: FiltersRecord
  onRemove: (key: string, value?: string) => void
}

export const ActiveFiltersBar: FunctionComponent<ActiveFiltersBarProps> = ({
  filters,
  onRemove
}) => {
  const [usersMap, setUsersMap] = useState<UsersDisplayMap>({})

  useEffect(() => {
    let mounted = true

    getUsersDisplayMap().then((map) => {
      if (mounted) setUsersMap(map)
    })

    return () => {
      mounted = false
    }
  }, [])

  const entries = useMemo(() => {
    const list: { key: string; raw: string }[] = []

    Object.entries(filters ?? {}).forEach(([key, raw]) => {
      if (raw === undefined || raw === null) return

      const asArray = Array.isArray(raw)
        ? raw
        : String(raw)
            .split(',')
            .map((v) => v.trim())
            .filter(Boolean)

      if (!asArray.length) return

      asArray.forEach((v) => list.push({ key, raw: String(v) }))
    })

    return list
  }, [filters])

  if (!entries.length) return <></>

  return (
    <HStack
      alignItems="center"
      justifyContent="flex-end"
      flexWrap="wrap"
      width="full"
      mb={8}
      // @ts-ignore
      style={{ gap: 8 }}>
      <HStack
        flex={1}
        flexWrap="wrap"
        // @ts-ignore
        style={{ gap: 8 }}
        justifyContent="flex-end">
        {entries.map(({ key, raw }, idx) => {
          let displayValue = raw

          if (key === 'opportunity_type' && opportunityTypeLabels[raw]) {
            displayValue = opportunityTypeLabels[raw]
          }

          if (key === 'priority') {
            displayValue = getPriorityLabel(raw)
          }

          if (key === 'user_std_code' && usersMap[raw]) {
            displayValue = usersMap[raw]
          }

          return (
            <Pressable
              key={`${key}-${raw}-${idx}`}
              onPress={() => onRemove(key, raw)}
              _pressed={{ opacity: 0.7 }}
              {...(idx === entries.length - 1 && { marginRight: 2 })}>
              <HStack
                alignItems="center"
                bg="white"
                maxW="full"
                px={4}
                py={1}
                borderColor="gray.100"
                borderWidth="1px"
                borderRadius="8px">
                <Text fontSize="14px" color="gray.400">
                  {displayValue}
                </Text>

                <Box ml={2}>
                  <Icons.Close color="gray.300" size={4} />
                </Box>
              </HStack>
            </Pressable>
          )
        })}
      </HStack>
    </HStack>
  )
}
